import React from "react";
import BaseDataAssetList from "./baseDataAssetList";

const DataSetDetailDataAssetList = ({ shouldGrabFocus = true, title }: { shouldGrabFocus?: boolean; title: string }) => {
  return (
    <BaseDataAssetList
      shouldGrabFocus={shouldGrabFocus}
      title={title}
      excludedFilters={["dataSet"]}
    />
  );
};

export default DataSetDetailDataAssetList;
